import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';

export const experimentalMigrateTemplate: ExperimentalMutations['experimentalMigrateTemplate'] =
	async (_, { templateId }, { network }) => {
		const response = await network.cfetch(`/wiki/rest/api/template/${templateId}/convert`, {
			method: 'PUT',
		});
		return {
			success: response.ok,
		};
	};
